<script setup lang="ts">
type Props = {
  src: string,
  shouldShow: boolean,
};

const props = defineProps<Props>();
</script>
<template>
  <img v-if="props.shouldShow" :src="props.src">
</template>
